var React = require('react');

function Cutlery (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.5 31.5V19.5C15.1569 19.5 16.5 18.1569 16.5 16.5V6C16.5 4.34315 15.1569 3 13.5 3V12H10.5V3C8.84315 3 7.5 4.34315 7.5 6V16.5C7.5 18.1569 8.84315 19.5 10.5 19.5V31.5C10.5 32.3284 11.1716 33 12 33C12.8284 33 13.5 32.3284 13.5 31.5ZM27 31.5V6C27 4.34315 25.6569 3 24 3H22.5C20.8431 3 19.5 4.34315 19.5 6V19.5C19.5 21.1569 20.8431 22.5 22.5 22.5H24V31.5C24 32.3284 24.6716 33 25.5 33C26.3284 33 27 32.3284 27 31.5Z","fill":"#D33736"}));
}

Cutlery.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Cutlery;

Cutlery.default = Cutlery;
